import { useState } from "react";
import AppShell from "../components/layout/AppShell";
import PoliciesTab from "../components/insurance/PoliciesTab";
import QuotesTab from "../components/insurance/QuotesTab";
import ClaimsTab from "../components/insurance/ClaimsTab";
import InsurersTab from "../components/insurance/InsurersTab";
import RenewalPanel from "../components/insurance/RenewalPanel";

var TABS = [
  { key: "renovacoes", label: "Renovacoes" },
  { key: "apolices", label: "Apolices" },
  { key: "cotacoes", label: "Cotacoes" },
  { key: "sinistros", label: "Sinistros" },
  { key: "seguradoras", label: "Seguradoras" },
];

export default function InsurancePage() {
  var tabState = useState("renovacoes");
  var tab = tabState[0];
  var setTab = tabState[1];

  function handleStartQuote(policy) {
    setTab("cotacoes");
  }

  return (
    <AppShell activePage="seguros" title="Seguros">
      <div data-testid="insurance-page">
        <div className="flex gap-1 mb-6 bg-gray-100 rounded-xl p-1 overflow-x-auto">
          {TABS.map(function(t) {
            var active = tab === t.key;
            return (
              <button
                key={t.key}
                data-testid={"tab-" + t.key}
                onClick={function() { setTab(t.key); }}
                className={"flex-shrink-0 px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all " + (active ? "bg-white text-[#0A2F3D] shadow-sm" : "text-gray-500 hover:text-gray-700")}
              >{t.label}</button>
            );
          })}
        </div>
        {tab === "renovacoes" && <RenewalPanel onStartQuote={handleStartQuote} />}
        {tab === "apolices" && <PoliciesTab />}
        {tab === "cotacoes" && <QuotesTab />}
        {tab === "sinistros" && <ClaimsTab />}
        {tab === "seguradoras" && <InsurersTab />}
      </div>
    </AppShell>
  );
}
